import {
  CognitoUserPool,
  CognitoUser,
  AuthenticationDetails,
} from "amazon-cognito-identity-js";
import { COGNITO_CONFIG } from "./cognitoConfig";

const userPool = new CognitoUserPool({
  UserPoolId: COGNITO_CONFIG.UserPoolId,
  ClientId: COGNITO_CONFIG.ClientId,
});

export const signIn = (email, password) =>
  new Promise((resolve, reject) => {
    const user = new CognitoUser({ Username: email, Pool: userPool });
    const authDetails = new AuthenticationDetails({ Username: email, Password: password });
    user.authenticateUser(authDetails, {
      onSuccess: (session) => resolve({ session, user }),
      onFailure: (err) => reject(err),
    });
  });

export const signOut = () => {
  const user = getCurrentUser();
  if (user) user.signOut();
};

export const getCurrentUser = () => userPool.getCurrentUser();

export const getIdTokenClaims = () =>
  new Promise((resolve, reject) => {
    const user = getCurrentUser();
    if (!user) return reject(new Error("No current user"));
    user.getSession((err, session) => {
      if (err) return reject(err);
      if (!session?.isValid()) return reject(new Error("Session expired"));
      resolve(session.getIdToken().payload || {});
    });
  });
